/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectResponse } from '../../models/delete-project-response';

export interface ProjectsControllerDeleteProject$Params {

/**
 * Project id.
 */
  id: string;
}

export function projectsControllerDeleteProject(http: HttpClient, rootUrl: string, params: ProjectsControllerDeleteProject$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerDeleteProject.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectResponse>;
    })
  );
}

projectsControllerDeleteProject.PATH = '/planning-projects/v1-develop/projects/{id}';
